# frozen_string_literal: true

require_relative 'choose'

module Engine
  module Action
    class ChooseAbility < Choose
    end
  end
end
